import { render, staticRenderFns } from "./reservation-filter.vue?vue&type=template&id=96980bee&scoped=true&"
import script from "./reservation-filter.vue?vue&type=script&lang=js&"
export * from "./reservation-filter.vue?vue&type=script&lang=js&"
import style0 from "./reservation-filter.vue?vue&type=style&index=0&id=96980bee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96980bee",
  null
  
)

export default component.exports